import React, { useState } from 'react'
import { toast } from 'react-toastify';
import './assets/emailConfiramtion.css'
import Modal from 'react-bootstrap/Modal';  
import { shallowEqual, useSelector } from 'react-redux'; 
import { HOST_URL, MediaBaseUrl } from '../../../../../../actions/api';
import { reSendEmail } from '../../../../../../actions/dashboardActions';
import { Button } from 'react-bootstrap';

const EmailConfirmation = () => {

	const show = true;
	const { userData } = useSelector(state=>state.authenticated,shallowEqual);
	const [emailId, setEmailId] = useState(userData.user.emailId)
	const [loaderShow, setLoaderShow] = useState(false);

	const textEmailChange = event => setEmailId(event.target.value)

	const logoutUser = () => {
        localStorage.clear();
        window.location.href = `${HOST_URL}`
    }

	const clickToReSendMail = event => {
		if(!loaderShow){
			setLoaderShow(true)
			reSendEmail(emailId, 4).then((response) => {
				toast.success("Email Sent Successfully.")
				setLoaderShow(false)
			}).catch((error) => {
				if(error && Object.keys(error).length > 0){
					const { response } = error;
					if(response && Object.keys(response).length > 0){
						const { data } = response;
						if(data && Object.keys(data).length > 0){
							const { responseMessage } = data;
							toast.error(responseMessage,{ autoClose: 3000} );
						}
					}
				}
				setLoaderShow(false)
			})
		}
	}

	return (
		<>
			<Modal show={show} size="lg" centered>
				<div id="email_confirmation" className="emailverify model fade show react-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
					<div className="modal-body text-right">
						<div onClick={()=>logoutUser()} className="btn p-0 text-muted">Sign Out</div>
						<div className="mb-10">
							<div className="text-center pb-lg-3">
								<img className="img-fluid mb-10" src={`${MediaBaseUrl}dashboard/email_icon.svg`} height="185" width="276" />


								<h3 className="text-center mb-5">You're just a step away.</h3>
								<p className="font-weight-bold text-dark-75 text-center">
									We have sent an email to <strong className="font-weight-boldest">{userData && userData.user? userData.user.emailId:''}</strong> with the verification link. Please go to your email account to verify. If you don't see the email in your inbox or spam folder, try resending the email here:
								</p>

							</div>
							<div className="f-center text-start w-100 mb-4 mt-5 mx-auto" style={{ maxWidth: "420px" }}>
								<label className='flex-grow-1'>
									<input type="email" className="form-control p-3 border-secondary" placeholder="example@mail.com" name="emailId" value={emailId} onChange={textEmailChange} />
									<span id="accountsemailIderror" className="error d-block m-0">
									</span>
								</label>
								<Button variant='primary' onClick={clickToReSendMail} className={`ms-2 text-nowrap py-3 px-4 ${loaderShow ? `ladda-button spinner spinner-white spinner-right disabled` : ``}`}  >Resend Email
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Modal>
			<div className="modal-overlay--blur"></div>




		</>
	)
}

export default EmailConfirmation